import React, { Fragment, useReducer } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import ai from "../../helpers/axios";
import { LoadingButton } from "../shared/loading-button";
import ReactModal from "react-modal";

const reducer = (state, action) => {
  switch (action.type) {
    case "fieldChanged":
      return { ...state, [action.field]: action.value };
    default:
      throw new Error();
  }
};

const initialState = {
  isSaving: false,
  isConfirmModalOpen: false,
  contents: "",
};

const AppMessageForm = ({ recordId, recordType, parentDispatch, setUnsavedChanges }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  const handleFormSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch({
      type: "fieldChanged",
      field: "isConfirmModalOpen",
      value: true,
    });
  };

  const handleFormSubmitConfirm = async () => {
    await handleMessageSubmit();
    dispatch({
      type: "fieldChanged",
      field: "isConfirmModalOpen",
      value: false,
    });
  };

  const handleFormSubmitCancel = () => {
    dispatch({
      type: "fieldChanged",
      field: "isConfirmModalOpen",
      value: false,
    });
  };

  const handleMessageSubmit = async () => {
    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    const message = {
      contents: state.contents,
      recordType: recordType,
      recordId: recordId,
    };

    if (!recordType || !recordId) {
      return;
    }

    dispatch({
      type: "fieldChanged",
      field: "isSaving",
      value: true,
    });

    await ai
      .auth(token)
      .post(`/api/appMessages/create`, message)
      .catch((e) => console.error(e));

    dispatch({
      type: "fieldChanged",
      field: "isSaving",
      value: false,
    });

    // Clear the input field
    dispatch({
      type: "fieldChanged",
      field: "contents",
      value: "",
    });

    setUnsavedChanges?.({
      section: "appMessages",
      value: false,
    });

    // Notify parent component to refresh message list
    parentDispatch({
      type: "rootFieldChanged",
      field: "latestAppMessage",
      value: Date.now(),
    });
  };

  const handleFieldChange = (event) => {
    dispatch({
      type: "fieldChanged",
      field: event.target.name,
      value: event.target.value,
    });

    setUnsavedChanges?.({
      section: "appMessages",
      value: event.target.value !== "",
    });
  };

  return (
    <Fragment>
      <form className="message-form app-message-form" onSubmit={handleFormSubmit}>
        <input
          type="text"
          name="contents"
          value={state.contents}
          onChange={handleFieldChange}
          placeholder="Type a message to client"
        />

        <button type="submit" className="send-btn" name="send">
          <span className="material-icons">send</span>
        </button>
      </form>

      <ReactModal
        isOpen={state.isConfirmModalOpen}
        shouldCloseOnEsc={false}
        shouldCloseOnOverlayClick={false}
        onRequestClose={handleFormSubmitCancel}
        style={{
          overlay: {
            zIndex: 999999,
            backgroundColor: "rgb(32 53 68 / 50%)",
          },
          content: {
            width: "auto",
            border: "none",
            maxWidth: "700px",
            maxHeight: "80vh",
            minWidth: "calc(min(500px, 95vw))",
            borderRadius: "0",
            boxShadow: "10px 10px 91px -17px rgb(0 0 0 / 25%)",
          },
        }}
        appElement={document.getElementById("app")}
      >
        <div className="modal-header base-modal">
          <h4>
            Send Message to Client App?
          </h4>
        </div>

        <div className="modal-body base-modal modal-body-with-scroll">
          <div className="w-100 mt-20">
            You are about to send this message to the Prospect in the Client App. Do you want to proceed?
          </div>
        </div>

        <div className="modal-footer w-100 mt-20 d-flex gap-20">

          <button
            className="base-button evo-blue flex-half"
            type="button"
            onClick={handleFormSubmitCancel}
            disabled={state.isSaving}
          >
            Cancel
          </button>

          <LoadingButton
            isLoading={state.isSaving}
            className="base-button btn-danger flex-half"
            type="button"
            onClick={handleFormSubmitConfirm}
          >
            Send Message
          </LoadingButton>
        </div>
      </ReactModal>
    </Fragment>
  );
};

export default AppMessageForm;
